import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { format, addDays } from "date-fns";
import { Search } from "lucide-react";
import { api } from "@/lib/api";

const ymd = (d) => format(d, "yyyy-MM-dd");
const field = "h-12 w-full rounded-md border border-[#E2DACF] px-3 text-sm bg-white";

function Num({ label, value, set, min, max, testid }) {
  return (
    <div>
      <label className="jt-eyebrow mb-2 block">{label}</label>
      <select className={field} value={value} onChange={(e) => set(Number(e.target.value))} data-testid={testid}>
        {Array.from({ length: max - min + 1 }, (_, i) => min + i).map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
    </div>
  );
}

export function StaysSearch() {
  const nav = useNavigate();
  const [hotels, setHotels] = useState([]);
  const [slug, setSlug] = useState("");
  const [checkIn, setCheckIn] = useState(ymd(addDays(new Date(), 1)));
  const [checkOut, setCheckOut] = useState(ymd(addDays(new Date(), 3)));
  const [rooms, setRooms] = useState(1);
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  useEffect(() => { api.get("/hotels").then((r) => setHotels(r.data)).catch(() => {}); }, []);

  const search = () => {
    const p = new URLSearchParams({ check_in: checkIn, check_out: checkOut, rooms, adults, children });
    nav(slug ? `/stays/${slug}?${p}` : "/stays");
  };

  return (
    <div className="bg-white/95 p-6 md:p-8 rounded-2xl rounded-tl-none shadow-2xl shadow-black/20 ring-1 ring-black/5" data-testid="stays-search">
      <div className="grid gap-4 grid-cols-2 md:grid-cols-4">
        <div className="col-span-2">
          <label className="jt-eyebrow mb-2 block">Property</label>
          <select className={field} value={slug} onChange={(e) => setSlug(e.target.value)} data-testid="stays-search-property">
            <option value="">All stays in Jawai</option>
            {hotels.map((h) => <option key={h.id} value={h.slug}>{h.name}</option>)}
          </select>
        </div>
        <div>
          <label className="jt-eyebrow mb-2 block">Check-in</label>
          <input type="date" className={field} value={checkIn} min={ymd(new Date())} data-testid="stays-search-checkin"
            onChange={(e) => { setCheckIn(e.target.value); if (e.target.value >= checkOut) setCheckOut(ymd(addDays(new Date(e.target.value), 1))); }}/>
        </div>
        <div>
          <label className="jt-eyebrow mb-2 block">Check-out</label>
          <input type="date" className={field} value={checkOut} min={ymd(addDays(new Date(checkIn), 1))} data-testid="stays-search-checkout"
            onChange={(e) => setCheckOut(e.target.value)}/>
        </div>
        <Num label="Rooms" value={rooms} set={setRooms} min={1} max={6} testid="stays-search-rooms"/>
        <Num label="Adults" value={adults} set={setAdults} min={1} max={12} testid="stays-search-adults"/>
        <Num label="Children" value={children} set={setChildren} min={0} max={8} testid="stays-search-children"/>
        <div className="flex items-end">
          <button onClick={search} className="jt-pill-accent inline-flex items-center justify-center gap-2 w-full h-12" data-testid="stays-search-btn">
            <Search size={16}/> Search
          </button>
        </div>
      </div>
    </div>
  );
}
